<script lang="ts">
  import { FeaturedIcon } from 'core-components';
</script>

<div class="suspended">
  <div class="card">
    <FeaturedIcon type="gray" theme="modern" icon="noConnection" />
    <hgroup>
      <h1 class="title">Oops, page not found</h1>
      <p class="subtitle">
        The page you are looking for does not exist or an error occurred. Try
        checking later.
      </p>
    </hgroup>
  </div>
</div>

<style lang="scss">
  .suspended {
    position: fixed;
    top: 48px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100svh - 48px); // min height - banner
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 10;

    @media screen and (max-width: 768px) {
      align-items: flex-start;
      padding: calc(var(--spacing-huge) + var(--spacing-mini))
        var(--spacing-mini);
    }

    .card {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--spacing-mini);
      width: 100%;
      max-width: 400px;
      padding: var(--spacing-small) var(--spacing-xsmall);
      border-radius: 12px;
      background-color: var(--color-neutralWhite);
      border: 1px solid var(--color-neutralExtraLight);
      box-shadow:
        0px 1px 2px 0px rgba(0, 0, 0, 0.02),
        0px 2px 4px 0px rgba(17, 17, 17, 0.04);
    }

    hgroup {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: var(--spacing-nano);
    }

    .title {
      font-size: 24px;
      line-height: 100%;
    }

    .subtitle {
      color: var(--color-neutralGreyLight, #787e87);
      font-size: 14px;
      line-height: 150%;
      letter-spacing: 0.14px;
    }
  }
</style>
